// removed by extract-text-webpack-plugin
module.exports = {"loading-container":"_1pSmXJmhAg39Tz5SZU6Rv","loadingContainer":"_1pSmXJmhAg39Tz5SZU6Rv","touch-to-start":"_14Q6aPdpdj-hKBvL7T-WZO","touchToStart":"_14Q6aPdpdj-hKBvL7T-WZO"};